
import { AdItem } from './types';

/**
 * Generate random ad data for demo purposes
 */
export function getSampleAdData(): AdItem[] {
  const adNames = [
    'Immobilienberater München',
    'Wohnungssuche Berlin Provisionsfreie',
    'Eigentumswohnung Frankfurt kaufen',
    'Makler Hamburg Verkauf',
    'Kapitalanlage Berlin Neubau'
  ];
  
  return adNames.map((name, index) => {
    // Generate realistic metrics
    const impressions = Math.floor(Math.random() * 10000) + 1000;
    const ctr = (Math.random() * 3 + 0.5).toFixed(2); // CTR between 0.5 and 3.5%
    const clicks = Math.round(impressions * (parseFloat(ctr) / 100));
    const leads = Math.round(clicks * (Math.random() * 0.1 + 0.05)); // 5-15% conversion
    const cpc = (Math.random() * 2 + 0.8).toFixed(2); // CPC between 0.8 and 2.8
    const totalCost = Math.round(clicks * parseFloat(cpc) * 100) / 100;
    const costPerLead = leads > 0 ? Math.round((totalCost / leads) * 100) / 100 : 0;
    
    return {
      id: `ad_${index + 1}`,
      name,
      headline: `${name} - Jetzt entdecken!`,
      imageUrl: getRandomAdImage(),
      lastUpdated: new Date().toISOString(),
      rank: index + 1,
      status: Math.random() > 0.2 ? 'Active' : 'Paused',
      leads,
      costPerLead,
      totalCost,
      ctr: parseFloat(ctr),
      cpc: parseFloat(cpc),
      performance: {
        clicks,
        impressions,
        ctr: parseFloat(ctr),
        spend: totalCost,
        leads,
        cpl: costPerLead
      }
    };
  });
}

/**
 * Returns a random ad image URL from our predefined set
 */
export function getRandomAdImage(): string {
  const images = [
    '/lovable-uploads/1deec01e-9914-4933-ad6a-5e5a42640618.png',
    '/lovable-uploads/368089c9-dc8d-47c3-af5c-f00bc647eaca.png',
    '/lovable-uploads/4639941b-464f-41f0-8edb-cf12d26f72f1.png',
    '/lovable-uploads/64d570bc-dd4c-4143-9dd1-f5838521c057.png',
    '/lovable-uploads/6a709ddd-a249-44fe-b0cc-47e3d5fbf1b0.png',
    '/lovable-uploads/a436215d-652d-4f4a-b003-7950e32305b2.png'
  ];
  
  return images[Math.floor(Math.random() * images.length)];
}
